import React, { useState, useEffect, useContext } from "react";
import AdminContext from "../../StateContext/Application";
import { apiurl } from "../../../../path";
import { Link, useNavigate } from "react-router-dom";
import {
  Back32,
  Cancel32,
  ProposalCreation32,
  submit,
} from "../../../../public/LoginImages/importimages";
import "./CreateWorkOrder/workorder.css";
import { useLanguage } from "../../../../lang/langcontext/LanguageContext";
import GooglePagination from "../../styles/GooglePagination";
import { formatDateTime, formatDate, formatFileName, useDepartmentFilter, formatIndianAmount  } from "../../../../utils/DateFormat";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const WorkOrderInwardList = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const context = useContext(AdminContext);
  const { GetWorkOrderInwardsList, WorkOrderApprovalOperation, GetMyDepartmentAccess } = context;

  const { departments, departmentId, setDepartmentId, ready } =
  useDepartmentFilter(GetMyDepartmentAccess);

  const nav = useNavigate();
  const [technicalInwards, setTechnicalInwards] = useState([]);
  const [loading, setLoading] = useState(false);
  const [SelectedOptions, setSelectedOptions] = useState("Pending");
  const [selectedBills, setSelectedBills] = useState([]);
    const [selectedHeadCode, setSelectedHeadCode] = useState("");
  const [filteredBills, setFilteredBills] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [rejectPanelhide, setRejectpanelhide] = useState(1);
  const [remark, setRemark] = useState("");
  const [showSpecific, setShowSpecific] = useState("0");
  const [showSpecificWorkDetail, setShowSpecificWorkDetail] = useState("");
  const [showSpecificID, setShowSpecificWorkID] = useState("");
  // filter
  const [selectedWorkType, setSelectedWorkType] = useState("");
  const [mhuidSearch, setMhuidSearch] = useState("");
  useEffect(() => {
    if (showSpecificID) {
      const specificWork = filteredBills.filter(
        (bill) => bill.WorkOrderNo?.trim() === showSpecificID?.trim(),
      );
      setShowSpecificWorkDetail(specificWork);
    } else {
      setShowSpecificWorkDetail([]);
    }
  }, [showSpecificID, filteredBills]);

  // INNER TABLE PAGINATION
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;

  // OUTER TABLE PAGINATION
  const [outerCurrentPage, setOuterCurrentPage] = useState(1);
  const outerBillsPerPage = 10;
  const totalPages = Math.ceil(showSpecificWorkDetail?.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  //     const sortedBills = Array.isArray(filteredBills)? filteredBills.slice() // ✅ prevent state mutation
  // .sort((a, b) => new Date(b.Date) - new Date(a.Date))
  //         : [];

  // ================= INNER TABLE PAGINATION =================
  const sortedBills = filteredBills;

  const filteredBills1 = sortedBills?.slice(indexOfFirstBill, indexOfLastBill);

  // ================= OUTER TABLE UNIQUE DATA =================

  const uniqueOuterBills = filteredBills?.filter(
    (val, index, self) =>
      index === self.findIndex((v) => v.WorkOrderNo === val.WorkOrderNo),
  );

  // ================= OUTER TABLE PAGINATION =================

  const outerIndexOfLastBill = outerCurrentPage * outerBillsPerPage;

  const outerIndexOfFirstBill = outerIndexOfLastBill - outerBillsPerPage;

  const outerTotalPages = Math.ceil(
    uniqueOuterBills.length / outerBillsPerPage,
  );

  const paginatedOuterBills = uniqueOuterBills?.slice(
    outerIndexOfFirstBill,
    outerIndexOfLastBill,
  );
  const currentBills = showSpecificWorkDetail?.slice(
    indexOfFirstBill,
    indexOfLastBill,
  );

  const [exportingPDF, setExportingPDF] = useState(false);

    // ////////////////////////////////
  const parseIds = (v) => {
    if (v === null || v === undefined || v === "") {
      return [];
    }
  
    try {
      const p = typeof v === "string" ? JSON.parse(v) : v;
  
      return (Array.isArray(p) ? p : [p])
        .map(Number)
        .filter((n) => Number.isInteger(n) && n > 0);
    } catch {
      return [];
    }
  };
  
  // Department Access States
  
  const [myDepartments, setMyDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [departmentLoading, setDepartmentLoading] = useState(true);
  
  useEffect(() => {
    let active = true;
  
    const fetchDepartments = async () => {
      try {
        const response = await GetMyDepartmentAccess();
  
        console.log("GetMyDepartmentAccess response:", response);
  
        // Supports an Axios response or an already-unwrapped response
        const payload = response?.data?.status
          ? response.data.data
          : response?.status === true
            ? response.data
            : response?.data?.data ?? response?.data ?? response;
  
        // getAdminAccess may return a department list or an access object
        const departmentList = Array.isArray(payload)
          ? payload
          : payload?.departments ?? payload?.Departments ?? [];
  
        const accessIds = parseIds(
          payload?.DepartmentAccessID ??
          payload?.departmentAccessID ??
          payload?.user?.DepartmentAccessID
        );
  
        const departments = Array.isArray(departmentList)
          ? departmentList
              .map((dept) => ({
                id: Number(dept.id ?? dept.ID),
                name: dept.name ?? dept.Name ?? dept.Department_Name
              }))
              .filter((dept) =>
                Number.isInteger(dept.id) && dept.id > 0
              )
          : [];
  
        // If API provides assigned IDs, restrict the department list
        const allowedDepartments = accessIds.length > 0
          ? departments.filter((dept) =>
              accessIds.includes(dept.id)
            )
          : departments;
  
        const uniqueDepartments = allowedDepartments.filter(
          (dept, index, self) =>
            self.findIndex((d) => d.id === dept.id) === index
        );
  
        if (!active) return;
  
        setMyDepartments(uniqueDepartments);
  
        // Single department automatically selected
        setSelectedDepartment(
          uniqueDepartments.length === 1
            ? String(uniqueDepartments[0].id)
            : ""
        );
  
        console.log("Allowed Departments:", uniqueDepartments);
      } catch (error) {
        console.error("Department API Error:", error);
  
        if (active) {
          setMyDepartments([]);
          setSelectedDepartment("");
        }
      } finally {
        if (active) setDepartmentLoading(false);
      }
    };
  
    fetchDepartments();
  
    return () => {
      active = false;
    };
  }, [GetMyDepartmentAccess]);
  
  

  
  // //////Added new
  const exportOuterTableToExcel = () => {
    if (!Array.isArray(uniqueOuterBills) || uniqueOuterBills.length === 0) {
      alert("No data available");
      return;
    }

    try {
      const getNumber = (value) => {
        if (value === null || value === undefined || value === "") return 0;

        const num = Number(String(value).replace(/,/g, ""));
        return isNaN(num) ? 0 : num;
      };

      // Calculate totals from ALL records
      const totalApprovedAmount = uniqueOuterBills.reduce(
        (sum, item) => sum + getNumber(item.ApprovedWorkAmount),
        0
      );

      const totalRemainingAmount = uniqueOuterBills.reduce(
        (sum, item) => sum + getNumber(item.RemainingAmount),
        0
      );

      const excelData = uniqueOuterBills.map((item, index) => ({
        "Sr.No": index + 1,

        "Work Order Number": item.WorkOrderNo || "",

        "MHUID Number": item.TechnicalUID || "",

        Taluka: item.ulb || "",

        "Administrative Approved Year": item.ProposalYear || "",

        "Head Code": item.HeadCode || "",

        "Vendor Name": item.ContractorName || "",

        "Work Order Name": item.WorkName || "",

        "Work Order Type": item.WorkOrderType || "-",

        "Job ID": item.JOB_ID ?? "-",

        "Approve Work Amount": getNumber(item.ApprovedWorkAmount),

        "Remaining Amount": getNumber(item.RemainingAmount),

        "Work Order Creation Date": item.Date
          ? new Date(item.Date).toLocaleDateString("en-GB")
          : "",

        "Work Order Date": item.WorkOrderDate
          ? new Date(item.WorkOrderDate).toLocaleDateString("en-GB")
          : "",

        "Work Order End Date": item.WorkEndDate
          ? new Date(item.WorkEndDate).toLocaleDateString("en-GB")
          : "",

        "Work Order Approval Date": item.workApprovedGRDate
          ? item.workApprovedGRDate.split("-").reverse().join("/")
          : "",

        "Copy of Work Order": item.CopyofWorkOrder || "No File",
      }));

      // TOTAL ROW
      excelData.push({
        "Sr.No": "",
        "Work Order Number": "",
        "MHUID Number": "",
        Taluka: "",
        "Administrative Approved Year": "",
        "Head Code": "",
        "Vendor Name": "",
        "Work Order Name": "",
        "Work Order Type": "",
        "Job ID": "TOTAL",

        "Approve Work Amount": totalApprovedAmount,

        "Remaining Amount": totalRemainingAmount,
        "Work Order Creation Date": "",
        "Work Order Date": "",
        "Work Order End Date": "",
        "Work Order Approval Date": "",
        "Copy of Work Order": "",
      });

      const worksheet = XLSX.utils.json_to_sheet(excelData);

      worksheet["!cols"] = [
        { wch: 8 },
        { wch: 20 },
        { wch: 20 },
        { wch: 18 },
        { wch: 20 },
        { wch: 20 },
        { wch: 25 },
        { wch: 35 },
        { wch: 20 },
        { wch: 15 },
        { wch: 20 },
        { wch: 20 },
        { wch: 25 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 25 },
      ];

      // Format amount columns
      const amountColumnIndexes = [10, 11];

      amountColumnIndexes.forEach((colIndex) => {
        for (let row = 1; row <= excelData.length; row++) {
          const cellAddress = XLSX.utils.encode_cell({
            r: row,
            c: colIndex,
          });

          if (worksheet[cellAddress]) {
            worksheet[cellAddress].z = "#,##0.00";
          }
        }
      });

      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "Work Order Inward"
      );

      XLSX.writeFile(workbook, "WorkOrderInward.xlsx");
    } catch (error) {
      console.error("Excel Export Error:", error);
      alert("Excel export failed");
    }
  };
 
  const downloadTableOnlyAsPDF = async (
    tableClass,
    filename,
    title
  ) => {
    const CHUNK_SIZE = 500;

    if (
      !Array.isArray(uniqueOuterBills) ||
      uniqueOuterBills.length === 0
    ) {
      alert("No data available");
      return;
    }

    setLoading(true);
    setExportingPDF(true);

    await new Promise((res) => setTimeout(res, 300));

    let exportContainer = null;

    try {

      const getNumber = (value) => {
        if (
          value === null ||
          value === undefined ||
          value === ""
        ) {
          return 0;
        }

        const num = Number(
          String(value).replace(/,/g, "")
        );

        return isNaN(num) ? 0 : num;
      };

      const totalApprovedAmount =
        uniqueOuterBills.reduce(
          (sum, item) =>
            sum +
            getNumber(item.ApprovedWorkAmount),
          0
        );

      const totalRemainingAmount =
        uniqueOuterBills.reduce(
          (sum, item) =>
            sum +
            getNumber(item.RemainingAmount),
          0
        );

      const originalTable =
        document.querySelector(`.${tableClass}`);

      if (!originalTable) {
        throw new Error("Table not found");
      }

      exportContainer =
        document.createElement("div");

      exportContainer.style.position =
        "absolute";

      exportContainer.style.left =
        "-100000px";

      exportContainer.style.top = "0";

      exportContainer.style.background =
        "#ffffff";

      exportContainer.style.padding =
        "10px";

      exportContainer.style.width =
        "max-content";

      exportContainer.style.minWidth =
        "max-content";

      const exportTable =
        originalTable.cloneNode(false);

      exportTable.style.width =
        "max-content";

      exportTable.style.minWidth =
        "max-content";

      exportTable.style.borderCollapse =
        "collapse";

      exportTable.style.tableLayout =
        "auto";


      const originalThead =
        originalTable.querySelector("thead");

      if (originalThead) {
        const clonedThead =
          originalThead.cloneNode(true);

        // Remove the "View" column
        const headerCells =
          clonedThead.querySelectorAll("th");

        headerCells.forEach((th) => {
          const headerText =
            th.textContent
              .trim()
              .toLowerCase();

          if (
            headerText === "view" ||
            headerText.includes("view")
          ) {
            th.remove();
          }
        });

        clonedThead
          .querySelectorAll("th")
          .forEach((th) => {
            th.style.whiteSpace = "nowrap";
            th.style.padding = "6px 8px";
            th.style.fontSize = "10px";
            th.style.border = "1px solid #000";
            th.style.fontWeight = "bold";
          });

        exportTable.appendChild(
          clonedThead
        );
      }

      const tbody =
        document.createElement("tbody");

      uniqueOuterBills.forEach(
        (item, index) => {
          const tr =
            document.createElement("tr");

          const values = [
            index + 1,
            item.WorkOrderNo || "",
            item.TechnicalUID || "",
            item.ulb || "",
            item.ProposalYear || "",
            item.HeadCode || "",
            item.ContractorName || "",
            item.WorkName || "",
            item.WorkOrderType || "-",
            item.JOB_ID ?? "-",

            getNumber(
              item.ApprovedWorkAmount
            ),

            getNumber(
              item.RemainingAmount
            ),

            item.Date
              ? new Date(
                item.Date
              ).toLocaleDateString(
                "en-GB"
              )
              : "",

            item.WorkOrderDate
              ? new Date(
                item.WorkOrderDate
              ).toLocaleDateString(
                "en-GB"
              )
              : "",

            item.WorkEndDate
              ? new Date(
                item.WorkEndDate
              ).toLocaleDateString(
                "en-GB"
              )
              : "",

            item.workApprovedGRDate
              ? item.workApprovedGRDate
                .split("-")
                .reverse()
                .join("/")
              : "",

            item.CopyofWorkOrder ||
            "No File",
          ];

          values.forEach(
            (value, columnIndex) => {
              const td =
                document.createElement(
                  "td"
                );

              td.textContent =
                typeof value === "number"
                  ? value.toLocaleString(
                    "en-IN"
                  )
                  : value;

              td.style.border =
                "1px solid #000";

              td.style.padding =
                "5px 8px";

              td.style.fontSize =
                "9px";

              td.style.whiteSpace =
                "nowrap";

              td.style.verticalAlign =
                "middle";

              if (
                columnIndex === 1 ||
                columnIndex === 2 ||
                columnIndex === 6 ||
                columnIndex === 7 ||
                columnIndex === 12
              ) {
                td.style.minWidth =
                  "120px";
              }

              if (
                columnIndex === 7
              ) {
                td.style.minWidth =
                  "180px";
              }

              tr.appendChild(td);
            }
          );

          tbody.appendChild(tr);
        }
      );

      const totalRow =
        document.createElement("tr");

      const totalValues = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "TOTAL",
        totalApprovedAmount,
        totalRemainingAmount,
        "",
        "",
        "",
        "",
        "",
      ];

      totalValues.forEach(
        (value) => {
          const td =
            document.createElement(
              "td"
            );

          td.textContent =
            typeof value === "number"
              ? value.toLocaleString(
                "en-IN"
              )
              : value;

          td.style.border =
            "1px solid #000";

          td.style.padding =
            "7px 8px";

          td.style.fontSize =
            "10px";

          td.style.fontWeight =
            "bold";

          td.style.background =
            "#f2f2f2";

          td.style.whiteSpace =
            "nowrap";

          totalRow.appendChild(td);
        }
      );

      tbody.appendChild(totalRow);

      exportTable.appendChild(tbody);

      exportContainer.appendChild(
        exportTable
      );

      document.body.appendChild(
        exportContainer
      );

      const tableWidthPx =
        exportTable.scrollWidth;

      const tableHeightPx =
        exportTable.scrollHeight;

      const allRows =
        Array.from(
          exportTable.querySelectorAll(
            "tbody tr"
          )
        );

      const totalRows =
        allRows.length;
      for (
        let start = 0;
        start < totalRows;
        start += CHUNK_SIZE
      ) {
        const end = Math.min(
          start + CHUNK_SIZE,
          totalRows
        );

        const clonedTable =
          exportTable.cloneNode(true);

        clonedTable.style.width =
          "max-content";

        clonedTable.style.minWidth =
          "max-content";

        const clonedRows =
          clonedTable.querySelectorAll(
            "tbody tr"
          );

        clonedRows.forEach(
          (row, index) => {
            if (
              index < start ||
              index >= end
            ) {
              row.remove();
            }
          }
        );

        const chunkContainer =
          document.createElement(
            "div"
          );

        chunkContainer.style.position =
          "absolute";

        chunkContainer.style.left =
          "-100000px";

        chunkContainer.style.top =
          "0";

        chunkContainer.style.background =
          "#ffffff";

        chunkContainer.style.padding =
          "10px";

        chunkContainer.style.width =
          "max-content";

        chunkContainer.style.minWidth =
          "max-content";

        chunkContainer.appendChild(
          clonedTable
        );

        document.body.appendChild(
          chunkContainer
        );

        await new Promise((res) =>
          requestAnimationFrame(
            () =>
              requestAnimationFrame(
                res
              )
          )
        );


        const actualWidth =
          chunkContainer.scrollWidth;

        const actualHeight =
          chunkContainer.scrollHeight;

        console.log(
          `Chunk ${start + 1}-${end}`,
          {
            width: actualWidth,
            height: actualHeight,
          }
        );

        const canvas =
          await html2canvas(
            chunkContainer,
            {
              scale: 1.5,
              useCORS: true,
              backgroundColor:
                "#ffffff",

              /*
               * Do not crop horizontally.
               */
              width: actualWidth,

              windowWidth:
                actualWidth,

              scrollX: 0,
              scrollY: 0,
            }
          );


        const MM_PER_PX =
          0.264583;

        const pdfWidth =
          canvas.width *
          MM_PER_PX /
          1.5;

        // Minimum width
        const finalPdfWidth =
          Math.max(
            pdfWidth + 10,
            297
          );

        const pageHeight =
          210;

        const topMargin =
          18;

        const bottomMargin =
          10;

        const sideMargin =
          5;

        const pdf =
          new jsPDF(
            "landscape",
            "mm",
            [
              finalPdfWidth,
              pageHeight,
            ]
          );

        pdf.setFontSize(14);

        pdf.setFont(
          "helvetica",
          "bold"
        );

        pdf.text(
          `${title} (${start + 1} - ${end})`,
          finalPdfWidth / 2,
          10,
          {
            align: "center",
          }
        );

        const imgWidth =
          finalPdfWidth -
          sideMargin * 2;

        const pxToMm =
          imgWidth /
          canvas.width;

        const usableHeight =
          pageHeight -
          topMargin -
          bottomMargin;

        const usableHeightPx =
          usableHeight /
          pxToMm;

        let renderedHeight = 0;

        let pageNumber = 0;

        while (
          renderedHeight <
          canvas.height
        ) {
          const sliceHeight =
            Math.min(
              usableHeightPx,
              canvas.height -
              renderedHeight
            );

          const pageCanvas =
            document.createElement(
              "canvas"
            );

          const context =
            pageCanvas.getContext(
              "2d"
            );

          pageCanvas.width =
            canvas.width;

          pageCanvas.height =
            Math.ceil(
              sliceHeight
            );

          context.drawImage(
            canvas,

            0,
            renderedHeight,

            canvas.width,
            sliceHeight,

            0,
            0,

            canvas.width,
            sliceHeight
          );

          const imgData =
            pageCanvas.toDataURL(
              "image/jpeg",
              0.92
            );

          if (pageNumber > 0) {
            pdf.addPage();
          }

          pdf.addImage(
            imgData,
            "JPEG",
            sideMargin,
            topMargin,
            imgWidth,
            sliceHeight *
            pxToMm
          );

          renderedHeight +=
            sliceHeight;

          pageNumber++;
        }

        pdf.save(
          `${filename}_${start + 1}_to_${end}.pdf`
        );

        document.body.removeChild(
          chunkContainer
        );

        await new Promise((res) =>
          setTimeout(res, 300)
        );
      }
    } catch (error) {
      console.error(
        "PDF Export Error:",
        error
      );

      alert(
        "PDF export failed. Please try again."
      );
    } finally {
      if (
        exportContainer &&
        document.body.contains(
          exportContainer
        )
      ) {
        document.body.removeChild(
          exportContainer
        );
      }

      setExportingPDF(false);
      setLoading(false);
    }
  };
    // //////////////// 
 
// // TABLE 1 Excel export
// const exportOuterTableToExcel = () => {
//   if (!Array.isArray(uniqueOuterBills) || uniqueOuterBills.length === 0) {
//     alert("No data available");
//     return;
//   }
//   const excelData = uniqueOuterBills.map((item, index) => ({
//     "Sr.No": index + 1,
//     "Work Order Number": item.WorkOrderNo || "",
//     "MHUID Number": item.TechnicalUID || "",
//     Taluka: item.ulb || "",
//     "Administrative Approved Year": item.ProposalYear || "",
//     "Head Code": item.HeadCode || "",
//     "Vendor Name": item.ContractorName || "",
//     "Work Order Name": item.WorkName || "",
//     "Work Order Type": item.WorkOrderType || "-",
//     "Job ID": item.JOB_ID ?? "-",
//     "Approve Work Amount": item.ApprovedWorkAmount || "",
//     "Remaining Amount": item.RemainingAmount || "",
//     "Copy of Work Order": item.CopyofWorkOrder || "No File",
//     "Work Order Creation Date": item.Date ? new Date(item.Date).toLocaleDateString("en-GB") : "",
//     "Work Order Date": item.WorkOrderDate ? new Date(item.WorkOrderDate).toLocaleDateString("en-GB") : "",
//     "Work Order End Date": item.WorkEndDate ? new Date(item.WorkEndDate).toLocaleDateString("en-GB") : "",
//     "Work Order Approval Date": item.workApprovedGRDate ? item.workApprovedGRDate.split("-").reverse().join("/") : "",
//   }));
//   const worksheet = XLSX.utils.json_to_sheet(excelData);
//   worksheet["!cols"] = Object.keys(excelData[0]).map(() => ({ wch: 20 }));
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "Work Order Inward");
//   XLSX.writeFile(workbook, "WorkOrderInward.xlsx");
// };
 
// // Shared PDF export (used by both tables)
// const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
//   const CHUNK_SIZE = 500;
//   const originalTable = document.querySelector(`.${tableClass}`);
//   if (!originalTable) {
//     setExportingPDF(false);
//     alert("Table not found");
//     return;
//   }
//   setLoading(true);
//   setExportingPDF(true);
//   await new Promise((res) => setTimeout(res, 400));
//   try {
//     const table = document.querySelector(`.${tableClass}`);
//     const originalRows = table.querySelectorAll("tbody tr");
//     const totalRows = originalRows.length;
//     for (let start = 0; start < totalRows; start += CHUNK_SIZE) {
//       const end = Math.min(start + CHUNK_SIZE, totalRows);
//       const clonedTable = table.cloneNode(true);
//       const rows = clonedTable.querySelectorAll("tbody tr");
//       rows.forEach((row, index) => { if (index < start || index >= end) row.remove(); });
//       document.body.appendChild(clonedTable);
//       const pdf = new jsPDF("p", "mm", "a4");
//       const pageWidth = pdf.internal.pageSize.getWidth();
//       const pageHeight = pdf.internal.pageSize.getHeight();
//       const topMargin = 25, sideMargin = 10, bottomMargin = 15;
//       pdf.setFontSize(16);
//       pdf.setFont("helvetica", "bold");
//       pdf.text(`${title} (${start + 1} - ${end})`, pageWidth / 2, 15, { align: "center" });
//       const canvas = await html2canvas(clonedTable, { scale: 1, useCORS: true, backgroundColor: "#2C78DB" });
//       const imgWidth = pageWidth - sideMargin * 2;
//       const pxToMm = imgWidth / canvas.width;
//       const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
//       const usablePageHeightPx = usablePageHeightMm / pxToMm;
//       let renderedHeight = 0, pageNumber = 0;
//       while (renderedHeight < canvas.height) {
//         const sliceHeight = Math.min(usablePageHeightPx, canvas.height - renderedHeight);
//         const pageCanvas = document.createElement("canvas");
//         const context = pageCanvas.getContext("2d");
//         pageCanvas.width = canvas.width;
//         pageCanvas.height = sliceHeight;
//         context.drawImage(canvas, 0, renderedHeight, canvas.width, sliceHeight, 0, 0, canvas.width, sliceHeight);
//         const imgData = pageCanvas.toDataURL("image/jpeg", 0.85);
//         if (pageNumber > 0) pdf.addPage();
//         pdf.addImage(imgData, "JPEG", sideMargin, topMargin, imgWidth, sliceHeight * pxToMm);
//         renderedHeight += sliceHeight;
//         pageNumber++;
//       }
//       pdf.save(`${filename}_${start + 1}_to_${end}.pdf`);
//       document.body.removeChild(clonedTable);
//       await new Promise((res) => setTimeout(res, 300));
//     }
//   } catch (error) {
//     console.error("PDF Export Error:", error);
//   } finally {
//     setExportingPDF(false);
//     setLoading(false);
//   }
// };

  // const getTechnicalInwardsList = async () => {
  //   let data = await GetWorkOrderInwardsList("All", "null");
  //   console.log("dataworkkk------------", data);

  //   setTechnicalInwards(data);
  //   setFilteredBills(data);
  // };
  const getTechnicalInwardsList = async () => {
  try {
    const data = await GetWorkOrderInwardsList("All", null, departmentId);
    const list = Array.isArray(data) ? data : [];
    setTechnicalInwards(list);
    setFilteredBills(list);
  } catch (error) {
    console.error("Error fetching Technical Inwards:", error);
    setTechnicalInwards([]);
    setFilteredBills([]);
  }
};

useEffect(() => {
  if (!ready) return;
  getTechnicalInwardsList();
}, [ready, departmentId]);

  let inwardList = [];
  if (technicalInwards.length > 0) {
    inwardList = technicalInwards;
  }

  // useEffect(() => {
  //   const lowerSearchTerm = searchTerm.toLowerCase();
  //   const filtered = technicalInwards.filter((bill) =>
  //     Object.values(bill).some((val) =>
  //       (val || "").toString().toLowerCase().includes(lowerSearchTerm),
  //     ),
  //   );
  //   setFilteredBills(filtered);
  //   setCurrentPage(1);
  // }, [searchTerm, technicalInwards]);
  // useEffect(() => {
  //   if (technicalInwards) {
  //     let res = technicalInwards.filter(
  //       (item) => item.Status == SelectedOptions,
  //     );
  //     setFilteredBills(res);
  //   }
  // }, [SelectedOptions, technicalInwards]);
  // useEffect(() => {
  //   let filtered = technicalInwards;

  //   // Status Filter
  //   if (SelectedOptions) {
  //     filtered = filtered.filter((item) => item.Status === SelectedOptions);
  //   }

  //   // Work Type Filter
  //   if (selectedWorkType) {
  //     filtered = filtered.filter(
  //       (item) => item.WorkOrderType?.trim() === selectedWorkType.trim(),
  //     );
  //   }

  //   ////////
  //       // Head Code Filter
  //   if (selectedHeadCode) {
  //     filtered = filtered.filter(
  //       (item) =>
  //         item.HeadCode?.toString().trim() ===
  //         selectedHeadCode.toString().trim()
  //     );
  //   }
  //   ////////

  //   // MHUID Search Filter
  //   if (mhuidSearch) {
  //     filtered = filtered.filter((item) =>
  //       item.TechnicalUID?.toLowerCase().includes(mhuidSearch.toLowerCase()),
  //     );
  //   }

  //   // Global Search
  //   if (searchTerm) {
  //     const lowerSearchTerm = searchTerm.toLowerCase();

  //     filtered = filtered.filter((bill) =>
  //       Object.values(bill).some((val) =>
  //         (val || "").toString().toLowerCase().includes(lowerSearchTerm),
  //       ),
  //     );
  //   }

  //   setFilteredBills(filtered);
  //   setCurrentPage(1);
  // }, [
  //   technicalInwards,
  //   SelectedOptions,
  //   selectedWorkType,
  //   selectedHeadCode,
  //   mhuidSearch,
  //   searchTerm,
  // ]);

  useEffect(() => {
  let filtered = Array.isArray(technicalInwards) ? [...technicalInwards] : [];

  // Status
  if (SelectedOptions) {
    filtered = filtered.filter((item) => item.Status === SelectedOptions);
  }

  // Head code
  if (selectedHeadCode) {
    filtered = filtered.filter(
      (item) => item.HeadCode?.toString().trim() === selectedHeadCode.toString().trim(),
    );
  }

  // Work order type
  if (selectedWorkType) {
    filtered = filtered.filter(
      (item) => item.WorkOrderType?.trim() === selectedWorkType.trim(),
    );
  }

  // MHUID
  if (mhuidSearch) {
    filtered = filtered.filter((item) =>
      String(item.TechnicalUID ?? "").toLowerCase().includes(mhuidSearch.toLowerCase()),
    );
  }

  // Global search
  if (searchTerm) {
    const s = searchTerm.toLowerCase();
    filtered = filtered.filter((item) =>
      Object.values(item).some((v) => String(v ?? "").toLowerCase().includes(s)),
    );
  }

  setFilteredBills(filtered);
  setCurrentPage(1);
  setOuterCurrentPage(1);
}, [
  technicalInwards,
  SelectedOptions,
  selectedHeadCode,
  selectedWorkType,
  mhuidSearch,
  searchTerm,
]);


  useEffect(() => {
    if (technicalInwards) {
      let res = technicalInwards.filter(
        (item) => item.Status == SelectedOptions,
      );
      setFilteredBills(res);
    }
  }, [SelectedOptions, technicalInwards]);

  const handleCheckboxChange = (id) => {
    setSelectedBills((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((billId) => billId !== id)
        : [...prevSelected, id],
    );
  };

  console.log("Slected id form table :: ", selectedBills);
  console.log("Filtered data id form table :: ", filteredBills);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedBills(currentBills.map((bill) => bill.WorkOrderID));
    } else {
      setSelectedBills([]);
    }
  };

  const approveorrejectSelected = async (condition) => {
    if (selectedBills.length === 0) {
      alert("No Technical Sanction selected for approval!");
      return;
    }
    console.log(selectedBills);
    if (condition == "Rejected" || condition == "SendBack") {
      const cleanRemark = remark.trim().replace(/\s+/g, " ");

      // ❌ If remark is empty after trimming
      if (!cleanRemark) {
        alert("Remark is required and cannot be empty!");
        return;
      }
    }
    setLoading(true);

    let shouldStart = window.confirm("Are you sure ???");
    if (shouldStart) {
      try {
        let response = await WorkOrderApprovalOperation(
          selectedBills,
          condition,
          remark,
        );
        if (response.message) {
          alert(response.message);
          setRejectpanelhide(0);
          setRemark("");
          getTechnicalInwardsList();
          setLoading(false);
          window.location.reload();
        }
        if (response.error) {
          alert(response.error);
          setRejectpanelhide(0);
          setRemark("");
          getTechnicalInwardsList();
          setLoading(false);
          window.location.reload();
        }
      } catch (error) {
        console.error("Error approving Proposal:", error);
        alert("An error occurred while approving bills.");
        setRejectpanelhide(0);
        setLoading(false);
        setRemark("");
        window.location.reload();
      }
    } else {
      alert(`Gr ${condition} Operation Cancelled !!!`);
      setRemark("");
      setRejectpanelhide(0);
      getTechnicalInwardsList();
      window.location.reload();
    }
    setLoading(false); // Stop loader
  };

  const rejectSendbackbeforecheckup = (id) => {
    if (selectedBills.length > 0) {
      setRejectpanelhide(id);
    } else {
      alert("No Bill Selected !!!");
    }
  };

  return (
    <>
      <div
        className="col-12 pb-5"
        style={{
          backgroundColor: "#EFF3F8",
          height: "90vh",
          overflowX: "hidden",
          overflowY: "scroll",
        }}
      >
        <div className="col-12 px-3 m-auto">
          <div
            className="col-12 px-4 mb-4 mt-3"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h5 className="my-auto fw-bold">
              <img
                src="/GR-Approval64.png"
                alt="Technical Approval"
                style={{ width: "24px", height: "24px" }}
                className="my-auto me-1"
              />
              <span className="my-auto">{t("Work Order Inward List")}</span>
            </h5>

            {/* <input
                            type="text"
                            placeholder="Search"
                            onChange={(e) => setSearchTerm(e.target.value)}
                            value={searchTerm}
                            style={{ width: "250px", padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue', fontSize: "14px", marginRight: "10px" }} /> */}
            <div
              style={{
                position: "relative",
                width: "250px",
                marginRight: "10px",
              }}
            >
              <img
                src="/Search32.png"
                alt="Search Icon"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "10px",
                  transform: "translateY(-50%)",
                  width: "16px",
                  height: "16px",
                  opacity: 0.6,
                }}
              />
              <input
                type="text"
                placeholder={t("Search Here")}
                onChange={(e) => setSearchTerm(e.target.value)}
                value={searchTerm}
                style={{
                  width: "100%",
                  padding: "8px 12px 8px 32px", // left padding makes space for icon
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  backgroundColor: "#f1f6fc",
                  fontSize: "18px",
                  color: "#333",
                  boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                  outline: "none",
                }}
              />
            </div>
          </div>

          {loading && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(255, 255, 255, 0.7)",
                backdropFilter: "blur(4px)",
                zIndex: 9999,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  border: "6px solid #f3f3f3",
                  borderTop: "6px solid #007bff",
                  borderRadius: "50%",
                  width: "60px",
                  height: "60px",
                  animation: "spin 1s linear infinite",
                }}
              />
              <style>
                {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
              </style>
            </div>
          )}

          {/* <div className="col-12 my-4">
                        <div className="col-12 py-4 " style={{
                            background: 'linear-gradient(to right, #c8d0e3, #b7dff5)',
                            borderRadius: '10px'
                        }}>
                            <div className="col-8 m-auto">
                                <div className="row align-items-center">
                                    <div className="col-4 text-end">
                                        <label className='fw-bold'>{t("Select Status")}</label>
                                    </div>

                                    <div className="col-6">
                                        <select
                                            className='w-100 py-2 px-3'
                                            style={{
                                                border: 'none',
                                                borderRadius: '6px',
                                                outline: 'none',
                                                fontSize: '14px',
                                                boxShadow: '0 1px 2px rgba(0,0,0,0.1)'
                                            }}
                                            onChange={(e) => setSelectedOptions(e.target.value)}
                                        >
                                            <option value="Pending">{t("Approve")}</option>
                                            <option value="SendBack">{t("Send Back")}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}

          {/* ================= ROW 2 : Filters + Search ================= */}
          <div
            className="col-12 px-4 mb-4 mt-3"
            style={{
              display: "flex",
              gap: "5px",
              alignItems: "center",
            }}
          >

            {/* Department Filter - show only for multiple departments */}
{departments.length > 1 && (
  <select
    value={departmentId}
    onChange={(e) => setDepartmentId(e.target.value)}
    style={{ width: "170px", padding: "8px", border: "1px solid #ccc", borderRadius: "8px", fontSize: "18px" }}
  >
    <option value="">{t("All Departments")}</option>
    {departments.map((d) => (
      <option key={d.id} value={d.id}>{d.name || d.id}</option>
    ))}
  </select>
)}


            {/* Work Order Type Filter */}
            <select
              value={selectedWorkType}
              onChange={(e) => setSelectedWorkType(e.target.value)}
              style={{
                width: "170px",
                padding: "8px",
                border: "1px solid #ccc",
                borderRadius: "8px",
                fontSize: "18px",
              }}
            >
              <option value="">{t("All Work Types")}</option>
              <option value="New Work Order">{t("New Work Order")}</option>
              <option value="Existing Work Order">
                {t("Existing Work Order")}
              </option>
            </select>

            {/* //////////// */}
            {/* Head Code Filter */}
<select
  value={selectedHeadCode}
  onChange={(e) => setSelectedHeadCode(e.target.value)}
  style={{
    width: "200px",
    padding: "8px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    fontSize: "18px",
    backgroundColor: "#fff",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    flexShrink: 0
  }}
>
  <option value="">{t("Select Head Code")}</option>

  {[...new Set(
    technicalInwards
      ?.map((item) => item.HeadCode)
      .filter((code) => code)
  )].map((headCode, index) => (
    <option key={index} value={headCode}>
      {headCode}
    </option>
  ))}
</select>

            {/* //////////// */}

            {/* MHUID Search */}
            <div style={{ position: "relative", width: "200px" }}>
              <img
                src="/Search32.png"
                alt="Search"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "10px",
                  transform: "translateY(-50%)",
                  width: "16px",
                  opacity: 0.6,
                }}
              />
              <input
                type="text"
                placeholder={t("Search MHUID")}
                value={mhuidSearch}
                onChange={(e) => setMhuidSearch(e.target.value)}
                style={{
                  width: "100%",
                  padding: "4px 12px 4px 32px",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  backgroundColor: "#f1f6fc",
                  fontSize: "18px",
                }}
              />
            </div>
          </div>

          {showSpecific == "0" && (
            <div
              className="m-auto"
              style={{
                width: "98%",
                backgroundColor: "white",
                padding: "30px 30px",
                boxShadow: "0px 0px 5px 1px #c7c9cc",
                borderRadius: "20px",
              }}
            >

              <div className="d-flex justify-content-end gap-2 mb-3">
                <button className="btn btn-success" onClick={exportOuterTableToExcel}>
                  {t("Download Excel")}
                </button>
                <button
                  className="btn btn-danger"
                  onClick={() => downloadTableOnlyAsPDF("WorkOrderInwardOuterTable", "WorkOrderInward", "Work Order Inward Report")}
                >
                  {t("Download PDF")}
                </button>
              </div>

              <div
                className="col-12 tableDesign"
                style={{ background: "#2C78DB" }}
              >
                {SelectedOptions === "Pending" && (
                  <div
                    className="col-12 tableDesign"
                    style={{ background: "#2C78DB" }}
                  >
                    <div style={{ overflowX: "auto",maxWidth: "100%",  overflowX: "auto",
                      overflowY: "auto",
                      maxHeight: "600px", // change height as needed
                      position: "relative" }}>
                      <table
                        className="m-0 p-0 WorkOrderInwardOuterTable"
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <thead  style={{ position: "sticky",  backgroundColor: "#1976d2",
                      top: 0,
                      zIndex: 10,}}>
                          <tr
                            style={{
                              color: "white",
                              border: "none",
                              height: "3rem",
                              fontSize: "18px",
                            }}
                          >
                            {/* <th style={{ padding: "6px 10px", minWidth: "60px" }}>
                                                                    <input
                                                                        type="checkbox"
                                                                        onChange={handleSelectAll}
                                                                        checked={selectedBills.length === currentBills.length}
                                                                        className='my-auto'
                                                                        style={{ height: '1rem', width: '1rem' }}
                                                                    />
                                                                </th> */}
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "80px",
                              }}
                            >
                              {t("Sr. No.")}
                            </th>{" "}
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("View")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Work Order Number")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("MHUID Number")}
                            </th>
                            <th style={{ padding: "14px 20px", minWidth: "180px" }}>Taluka</th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Administrative Approved Year")}
                            </th>
                            <th style={{ padding: "14px 20px", minWidth: "180px" }}>  {t("Head code")}</th>
                            {/* <th style={{ padding: "14px 20px", minWidth: "180px" }}>Gram panchayat</th> */}
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Vendor Name")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "300px",
                              }}
                            >
                              {t("Work Order Name")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "300px",
                              }}
                            >
                              {t("Work Order Type")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Job ID")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Approve Work Amount")}
                            </th>
                            {/* <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Paid Amount")}
                            </th> */}
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Remaining Amount")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Work Order Creation Date")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("work Order Date")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Work Order End Date")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Work Order Approval Date")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Copy of Work Order")}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {paginatedOuterBills.length <= 0 ? (
                            <tr>
                              <td
                                colSpan="12"
                                style={{
                                  textAlign: "center",
                                  padding: "15px 10px",
                                  backgroundColor: "#f9f9f9",
                                }}
                              >
                                {t("No data available")}
                              </td>
                            </tr>
                          ) : (
                            paginatedOuterBills
                              .filter(
                                (val, index, self) =>
                                  index ===
                                  self.findIndex(
                                    (v) => v.WorkOrderNo === val.WorkOrderNo,
                                  ),
                              )
                              .map((technicalInwards, index) => {
                                const bgColor =
                                  index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                return (
                                  <tr
                                    style={{
                                      backgroundColor: bgColor,
                                      fontSize: "18px",
                                      fontWeight: "500",
                                    }}
                                    key={index}
                                  >
                                    {/* <td style={{ textAlign: "center" }}>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            className='my-auto'
                                                                                            style={{ height: '1rem', width: '1rem' }}
                                                                                            checked={selectedBills.includes(technicalInwards.WorkOrderID)}
                                                                                            onChange={() => handleCheckboxChange(technicalInwards.WorkOrderID)}
                                                                                        />
                                                                                    </td> */}
                                    <td className="py-2">
                                      {outerIndexOfFirstBill + index + 1}
                                    </td>
                                    <td className="py-2">
                                      <button
                                        onClick={(e) => {
                                          e.preventDefault();
                                          setShowSpecificWorkID(
                                            technicalInwards.WorkOrderNo,
                                          );
                                          setShowSpecific("1");
                                        }}
                                        className="m-auto text-center"
                                        style={{
                                          width: "5rem",
                                          fontWeight: "600",
                                          padding: "7px 3px",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          gap: "0.1rem",
                                          background:
                                            "linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)",
                                          color: "white",
                                          borderRadius: "8px",
                                        }}
                                      >
                                        {" "}
                                        <img
                                          src="/view32.png"
                                          style={{
                                            width: "0.9rem",
                                            height: "0.9rem",
                                            filter: "brightness(0) invert(1)",
                                          }}
                                        />
                                        {t("View")}
                                      </button>
                                    </td>
                                    <td className="py-2">
                                      {technicalInwards.WorkOrderNo}
                                    </td>
                                    <td className="py-2">
{!technicalInwards.TechnicalUID ||
 technicalInwards.TechnicalUID.toUpperCase() === "NULL"
  ? "--"
  : technicalInwards.TechnicalUID}
                                    </td>
                                    <td className='py-2'>{technicalInwards.ulb}</td>
                                    <td className="py-2">
                                      {technicalInwards.ProposalYear}
                                    </td>
                                    <td className='py-2'>{technicalInwards.HeadCode}</td>
                                    {/* <td className='py-2'>{technicalInwards.Gram_panchayat}</td> */}
                                    <td className="py-2">
                                      {technicalInwards.ContractorName}
                                    </td>
                                    <td className="py-2">
                                      {technicalInwards.WorkName}
                                    </td>
                                    <td className="py-2">
                                      {technicalInwards.WorkOrderType || "-"}
                                    </td>
                                    <td className="py-2">
                                      {technicalInwards.JOB_ID ?? "-"}
                                    </td>
                                    <td className="py-2">
                                      {formatIndianAmount(technicalInwards.ApprovedWorkAmount)}
                                    </td>
                                    {/* <td className="py-2">
                                      {technicalInwards.PaidAmount}
                                    </td> */}
                                    <td className="py-2">
                                      {formatIndianAmount(technicalInwards.RemainingAmount)}
                                    </td>
                                    <td className="py-2">
                                      {technicalInwards.Date
                                        ? formatDateTime(technicalInwards.Date)
                                        : ""}
                                    </td>
 
                                    <td className="py-2">
                                      {technicalInwards.WorkOrderDate
                                        ? formatDate(technicalInwards.WorkOrderDate)
                                        : ""}
                                    </td>
 
                                    <td className="py-2">
                                      {technicalInwards.WorkEndDate
                                        ? formatDate(technicalInwards.WorkEndDate)
                                        : ""}
                                    </td>
 
                                    <td className="py-2">
                                      {technicalInwards.workApprovedGRDate
                                        ? formatDate(technicalInwards.workApprovedGRDate)
                                        : ""}
                                    </td>
                                    <td style={{ padding: "8px" }}>
                                      {technicalInwards.CopyofWorkOrder ? (
                                        <>
                                          <div
                                            className="m-auto"
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "0.20rem",
                                              justifyContent: "center",
                                              width: "fit-content",
                                            }}
                                          >
                                            <img
                                              src="/pdf-32.png"
                                              alt="pdf"
                                              style={{
                                                width: "1.3rem",
                                                height: "1.3rem",
                                              }}
                                            />
                                            <a
                                              href={`${apiurl}/WorkOrderDocsImages/${technicalInwards.CopyofWorkOrder}`}
                                              target="_blank"
                                              style={{ fontSize: "18px" }}
                                              title={
                                                technicalInwards.CopyofWorkOrder
                                              }
                                            >
                                              {formatFileName(technicalInwards.CopyofWorkOrder)}
                                            </a>
                                          </div>
                                        </>
                                      ) : (
                                        <div
                                          className="m-auto"
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "0.20rem",
                                            justifyContent: "center",
                                            width: "fit-content",
                                          }}
                                        >
                                          <img
                                            src="/No-File32.png"
                                            alt="no file"
                                            style={{
                                              width: "1.3rem",
                                              height: "1.3rem",
                                            }}
                                          />
                                          <span className="text-danger fw-bold">
                                            {" "}
                                            {t("No File")}
                                          </span>
                                        </div>
                                      )}
                                    </td>
                                  </tr>
                                );
                              })
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                {SelectedOptions === "SendBack" && (
                  <div
                    className="col-12 tableDesign"
                    style={{ background: "#2C78DB" }}
                  >
                    <div style={{ overflowX: "auto", maxWidth: "100%" }}>
                      <table
                        className="m-0 p-0"
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <thead>
                          <tr
                            style={{
                              color: "white",
                              border: "none",
                              height: "3rem",
                              fontSize: "18px",
                            }}
                          >
                            {/* <th style={{ padding: "7px 10px", minWidth: "40px" }}>
                                                                    <input
                                                                        type="checkbox"
                                                                        onChange={handleSelectAll}
                                                                        checked={selectedBills.length === currentBills.length}
                                                                        style={{ height: '1rem', width: '1rem' }}
                                                                    />
                                                                </th> */}
                            {/* <th style={{ width: "3%" }}>View</th> */}
                            {/* <th style={{ width: "8%" }}>WorkOrderID</th> */}
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("View")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Work Order Number")}
                            </th>
                            {/* <th style={{ padding: "14px 20px", minWidth: "180px" }}>Edit</th> */}
                            {/* <th style={{ width: "5%" }}>HeadCode</th> */}
                            {/* <th style={{ width: "6%" }}>GR UID </th> */}
                            {/* <th style={{ padding: "14px 20px", minWidth: "180px" }}>Proposal UID </th> */}
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Proposal Year")}
                            </th>
                            {/* <th style={{ padding: "14px 20px", minWidth: "180px" }}>District</th> */}
                            {/* <th style={{ width: "8%" }}>PAN no</th> */}
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Vendor Name")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Work Name")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Work Order Type")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Job ID")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Approve Work Amount")}
                            </th>
                            {/* <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Paid Amount")}
                            </th> */}
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Remaining Amount")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Remark")}
                            </th>
                            {/* <th style={{ width: "8%" }}>Copy of Work Order</th> */}
                          </tr>
                        </thead>
                        {currentBills.length <= 0 ? (
                          <tr>
                            <td
                              colSpan="12"
                              style={{
                                textAlign: "center",
                                padding: "15px 10px",
                                backgroundColor: "#f9f9f9",
                              }}
                            >
                              {t("No data available")}
                            </td>
                          </tr>
                        ) : (
                          currentBills?.map((technicalInwards, index) => {
                            const bgColor =
                              index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                            return (
                              <tbody>
                                <tr
                                  style={{
                                    backgroundColor: bgColor,
                                    fontSize: "18px",
                                    fontWeight: "500",
                                  }}
                                  key={index}
                                >
                                  {/* <td style={{ textAlign: "center" }}>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            className='my-auto'
                                                                                            style={{ height: '1rem', width: '1rem' }}
                                                                                            checked={selectedBills.includes(technicalInwards.WorkOrderID)}
                                                                                            onChange={() => handleCheckboxChange(technicalInwards.WorkOrderID)}
                                                                                        />
                                                                                    </td> */}
                                  {/* <td className='py-2'><Link to={`/AdminDashboard/ProposalApprove/${technicalInwards.ProposalID}`}>View</Link></td> */}
                                  {/* <td className='py-2'>{technicalInwards.WorkOrderID}</td> */}
                                  <td className="py-2">
                                    <button
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setShowSpecificWorkID(
                                          technicalInwards.WorkOrderNo,
                                        );
                                        setShowSpecific("1");
                                      }}
                                      className="m-auto text-center"
                                      style={{
                                        width: "5rem",
                                        fontWeight: "600",
                                        padding: "7px 3px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: "0.1rem",
                                        background:
                                          "linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)",
                                        color: "white",
                                        borderRadius: "8px",
                                      }}
                                    >
                                      {" "}
                                      <img
                                        src="/view32.png"
                                        style={{
                                          width: "0.9rem",
                                          height: "0.9rem",
                                          filter: "brightness(0) invert(1)",
                                        }}
                                      />
                                      {t("View")}
                                    </button>
                                  </td>
                                  <td className="py-2">
                                    {technicalInwards.WorkOrderNo}
                                  </td>
                                  {/* <td className='py-2'>
                                                                                        <button
                                                                                            onClick={() => nav(`/AdminDashboard/EditWorkOrder/${technicalInwards.WorkOrderID}`)}
                                                                                            className='m-auto text-center'
                                                                                            style={{
                                                                                                width: "4rem", fontWeight: "600", padding: "7px 3px", display: "flex", justifyContent: "center", alignItems: "center", gap: "0.1rem",
                                                                                                background: 'linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)',
                                                                                                color: 'white', borderRadius: '4px',
                                                                                            }}
                                                                                        >
                                                                                            Edit
                                                                                        </button>
                                                                                    </td> */}
                                  {/* <td className='py-2'>{technicalInwards.HeadCode}</td> */}
                                  {/* <td className='py-2'>{technicalInwards.GrID}</td> */}
                                  {/* <td className='py-2'>{technicalInwards.ProposalID}</td> */}
                                  <td className="py-2">
                                    {technicalInwards.ProposalYear}
                                  </td>
                                  {/* <td className='py-2'>{technicalInwards.talulka}</td> */}
                                  {/* <td className='py-2'>{technicalInwards.PanNo}</td> */}
                                  <td className="py-2">
                                    {technicalInwards.ContractorName}
                                  </td>
                                  <td className="py-2">
                                    {technicalInwards.WorkName}
                                  </td>
                                  <td className="py-2">
                                    {technicalInwards.WorkOrderType || "-"}
                                  </td>
                                  <td className="py-2">
                                    {technicalInwards.JOB_ID ?? "-"}
                                  </td>
                                  <td className="py-2">
                                    {formatIndianAmount(technicalInwards.ApprovedWorkAmount)}
                                  </td>
                                  {/* <td className="py-2">
                                    {technicalInwards.PaidAmount}
                                  </td> */}
                                  <td className="py-2">
                                    {formatIndianAmount(technicalInwards.RemainingAmount)}
                                  </td>
                                  {/* <td style={{ padding: '8px' }}>{
                                            technicalInwards.CopyofWorkOrder ?
                                                (<a href={`${apiurl}/WorkOrderDocsImages/${technicalInwards.CopyofWorkOrder}`} target='_blank'>{technicalInwards.CopyofWorkOrder}</a>)
                                                :
                                                (<p className='text-danger my-auto fw-bold'>No Copy</p>)
                                        }
                                        </td> */}
                                  <td style={{ padding: "8px" }}>
                                    {technicalInwards.Remark}
                                  </td>
                                </tr>
                              </tbody>
                            );
                          })
                        )}
                      </table>
                    </div>
                  </div>
                )}
              </div>

              <div className="col-12 mt-3">
                <div
                  className="my-2 d-flex justify-content-between align-items-center"
                  style={{ flexWrap: "wrap" }}
                >
                  <p>
                    {t("Showing")}{" "}
                    {uniqueOuterBills.length > 0
                      ? outerIndexOfFirstBill + 1
                      : 0}{" "}
                    {t("to")}{" "}
                    {Math.min(outerIndexOfLastBill, uniqueOuterBills.length)}{" "}
                    {t("of")} {uniqueOuterBills.length} {t("entries")}
                  </p>
                  <div
                    className="col-6"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "end",
                    }}
                  >
                    <GooglePagination
                      currentPage={outerCurrentPage}
                      totalPages={outerTotalPages}
                      onPageChange={setOuterCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          {showSpecific == "1" && showSpecificID !== "" && (
            <div
              className="m-auto"
              style={{
                width: "98%",
                backgroundColor: "white",
                padding: "30px 30px",
                boxShadow: "0px 0px 5px 1px #c7c9cc",
                borderRadius: "20px",
              }}
            >
              <div className="col-12 text-start mb-3">
                <button
                  className="btn btn-danger px-3 py-1"
                  onClick={() => {
                    setShowSpecific("0");
                    setShowSpecificWorkID("");
                    setShowSpecificWorkDetail([]);
                    setSelectedBills([]);
                  }}
                >
                  {t("Back")}
                </button>
              </div>

              <div
                className="col-12 tableDesign"
                style={{ background: "#2C78DB" }}
              >
                {SelectedOptions === "Pending" && (
                  <div
                    className="col-12 tableDesign"
                    style={{ background: "#2C78DB" }}
                  >
                    <div style={{ overflowX: "auto", maxWidth: "100%" }}>
                      <table
                        className="m-0 p-0"
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <thead>
                          <tr
                            style={{
                              color: "white",
                              border: "none",
                              height: "3rem",
                              fontSize: "18px",
                            }}
                          >
                            <th
                              style={{ padding: "6px 10px", minWidth: "60px" }}
                            >
                              <input
                                type="checkbox"
                                onChange={handleSelectAll}
                                checked={
                                  selectedBills.length === currentBills.length
                                }
                                className="my-auto"
                                style={{ height: "1rem", width: "1rem" }}
                              />
                            </th>
                            {/* <th style={{ width: "3%" }}>View</th> */}
                            {/* <th style={{ width: "5%" }}>WorkOrderID</th> */}
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Work Order Number")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("MHUID Number")}
                            </th>
                            {/* <th style={{ width: "5%" }}>HeadCode</th> */}
                            {/* <th style={{ width: "5%" }}>GR UID </th> */}
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "220px",
                              }}
                            >
                              {t("Work Name")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Financial Year")}
                            </th>
                            {/* <th style={{ padding: "14px 20px", minWidth: "180px" }}>Gram panchayat</th> */}
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Job ID")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Vendor Name")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Work Order Name")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Work Order Type")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Work Cost")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Approve Work Order Amount")}
                            </th>
                            {/* <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Paid Amount")}
                            </th> */}
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Remaining Amount")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "220px",
                              }}
                            >
                              {t("Copy of Work Order")}
                            </th>
                            {/* <th style={{ padding: "14px 20px", minWidth: "100px" }}>Edit</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {currentBills.length <= 0 ? (
                            <tr>
                              <td
                                colSpan="12"
                                style={{
                                  textAlign: "center",
                                  padding: "15px 10px",
                                  backgroundColor: "#f9f9f9",
                                }}
                              >
                                {t("No data available")}
                              </td>
                            </tr>
                          ) : (
                            currentBills?.map((technicalInwards, index) => {
                              const bgColor =
                                index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                              return (
                                <tr
                                  style={{
                                    backgroundColor: bgColor,
                                    fontSize: "18px",
                                    fontWeight: "500",
                                  }}
                                  key={index}
                                >
                                  <td style={{ textAlign: "center" }}>
                                    <input
                                      type="checkbox"
                                      className="my-auto"
                                      style={{ height: "1rem", width: "1rem" }}
                                      checked={selectedBills.includes(
                                        technicalInwards.WorkOrderID,
                                      )}
                                      onChange={() =>
                                        handleCheckboxChange(
                                          technicalInwards.WorkOrderID,
                                        )
                                      }
                                    />
                                  </td>
                                  {/* <td className='py-2'><Link to={`/AdminDashboard/ProposalApprove/${technicalInwards.ProposalID}`}>View</Link></td> */}
                                  {/* <td className='py-2'>{technicalInwards.WorkOrderID}</td> */}
                                  <td className="py-2">
                                    {technicalInwards.WorkOrderNo}
                                  </td>
                                  <td className="py-2">
    {!technicalInwards.TechnicalUID ||
 technicalInwards.TechnicalUID.toUpperCase() === "NULL"
  ? "--"
  : technicalInwards.TechnicalUID}
                                  </td>
                                  {/* <td className='py-2'>{technicalInwards.HeadCode}</td> */}
                                  {/* <td className='py-2'>{technicalInwards.GrID}</td> */}
                                  <td className="py-2 px-3">
                                    {technicalInwards.ProposalID}
                                  </td>
                                  <td className="py-2">
                                    {technicalInwards.ProposalYear}
                                  </td>
                                  <td className="py-2">
                                    {technicalInwards.JOB_ID ?? "-"}
                                  </td>
                                  {/* <td className='py-2'>{technicalInwards.PanNo}</td> */}
                                  <td className="py-2">
                                    {technicalInwards.ContractorName}
                                  </td>
                                  <td className="py-2">
                                    {technicalInwards.WorkName}
                                  </td>
                                  <td className="py-2">
                                    {technicalInwards.WorkOrderType || "-"}
                                  </td>
                                  <td className="py-2">
                                    {formatIndianAmount(technicalInwards.ProjectCost)}
                                  </td>
                                  <td className="py-2">
                                    {formatIndianAmount(technicalInwards.ApprovedWorkAmount)}
                                  </td>
                                  {/* <td className="py-2">
                                    {technicalInwards.PaidAmount}
                                  </td> */}
                                  <td className="py-2">
                                    {formatIndianAmount(technicalInwards.RemainingAmount)}
                                  </td>
                                  <td className="px-3">
                                    {technicalInwards.CopyofWorkOrder ? (
                                      <>
                                        {/* <a href={`${apiurl}/WorkOrderDocsImages/${technicalInwards.CopyofWorkOrder}`} target='_blank'>{technicalInwards.CopyofWorkOrder}</a> */}
                                        <div
                                          className="m-auto"
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "0.20rem",
                                            justifyContent: "center",
                                            width: "fit-content",
                                          }}
                                        >
                                          <img
                                            src="/pdf-32.png"
                                            alt="pdf"
                                            style={{
                                              width: "1.3rem",
                                              height: "1.3rem",
                                            }}
                                          />
                                          <a
                                            href={`${apiurl}/WorkOrderDocsImages/${technicalInwards.CopyofWorkOrder}`}
                                            target="_blank"
                                            style={{ fontSize: "18px" }}
                                            title={
                                              technicalInwards.CopyofWorkOrder
                                            }
                                          >
                                            {formatFileName(technicalInwards.CopyofWorkOrder)}
                                          </a>
                                        </div>
                                      </>
                                    ) : (
                                      <div
                                        className="m-auto"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "0.20rem",
                                          justifyContent: "center",
                                          width: "fit-content",
                                        }}
                                      >
                                        <img
                                          src="/No-File32.png"
                                          alt="no file"
                                          style={{
                                            width: "1.3rem",
                                            height: "1.3rem",
                                          }}
                                        />
                                        <span className="text-danger fw-bold">
                                          {t("No File")}
                                        </span>
                                      </div>
                                    )}
                                  </td>

                                  {/* <td className='px-3'>
                                                                                        <button
                                                                                            onClick={() => nav(`/AdminDashboard/EditWorkOrder`, {
                                                                                                state: {
                                                                                                    id: technicalInwards.WorkOrderID
                                                                                                }
                                                                                            })}
                                                                                            className='m-auto text-center'
                                                                                            style={{
                                                                                                width: "4rem", fontWeight: "700", padding: "5px 10px", display: "flex", justifyContent: "center", alignItems: "center", gap: "0.1rem",
                                                                                                background: 'linear-gradient(to right, #2E7D32, #43A047, #4CAF50, #66BB6A)',
                                                                                                color: 'white', borderRadius: '4px'
                                                                                            }}
                                                                                        >
                                                                                            Edit
                                                                                        </button>
                                                                                    </td> */}
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                {SelectedOptions === "SendBack" && (
                  <div
                    className="col-12 tableDesign"
                    style={{ background: "#2C78DB" }}
                  >
                    <div style={{ overflowX: "auto", maxWidth: "100%" }}>
                      <table
                        className="m-0 p-0"
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <thead>
                          <tr
                            style={{
                              color: "white",
                              border: "none",
                              height: "3rem",
                              fontSize: "18px",
                            }}
                          >
                            <th
                              style={{ padding: "7px 10px", minWidth: "40px" }}
                            >
                              <input
                                type="checkbox"
                                onChange={handleSelectAll}
                                checked={
                                  selectedBills.length === currentBills.length
                                }
                                style={{ height: "1rem", width: "1rem" }}
                              />
                            </th>
                            {/* <th style={{ width: "3%" }}>View</th> */}
                            {/* <th style={{ width: "8%" }}>WorkOrderID</th> */}
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Work Order No")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Edit")}
                            </th>
                            {/* <th style={{ width: "5%" }}>HeadCode</th> */}
                            {/* <th style={{ width: "6%" }}>GR UID </th> */}
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Proposal UID")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Proposal Year")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("District")}
                            </th>
                            {/* <th style={{ width: "8%" }}>PAN no</th> */}
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Vendor Name")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Work Name")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Work Order Type")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Approve Work Amount")}
                            </th>
                            {/* <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Paid Amount")}
                            </th> */}
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Remaining Amount")}
                            </th>
                            <th
                              style={{
                                padding: "14px 20px",
                                minWidth: "180px",
                              }}
                            >
                              {t("Remark")}
                            </th>
                            {/* <th style={{ width: "8%" }}>Copy of Work Order</th> */}
                          </tr>
                        </thead>
                        {currentBills.length <= 0 ? (
                          <tr>
                            <td
                              colSpan="12"
                              style={{
                                textAlign: "center",
                                padding: "15px 10px",
                                backgroundColor: "#f9f9f9",
                              }}
                            >
                              {t("No data available")}
                            </td>
                          </tr>
                        ) : (
                          currentBills?.map((technicalInwards, index) => {
                            const bgColor =
                              index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                            return (
                              <tbody>
                                <tr
                                  style={{
                                    backgroundColor: bgColor,
                                    fontSize: "18px",
                                    fontWeight: "500",
                                  }}
                                  key={index}
                                >
                                  <td style={{ textAlign: "center" }}>
                                    <input
                                      type="checkbox"
                                      className="my-auto"
                                      style={{ height: "1rem", width: "1rem" }}
                                      checked={selectedBills.includes(
                                        technicalInwards.WorkOrderID,
                                      )}
                                      onChange={() =>
                                        handleCheckboxChange(
                                          technicalInwards.WorkOrderID,
                                        )
                                      }
                                    />
                                  </td>
                                  {/* <td className='py-2'><Link to={`/AdminDashboard/ProposalApprove/${technicalInwards.ProposalID}`}>View</Link></td> */}
                                  {/* <td className='py-2'>{technicalInwards.WorkOrderID}</td> */}
                                  <td className="py-2">
                                    {technicalInwards.WorkOrderNo}
                                  </td>
                                  <td className="py-2">
                                    <button
                                      onClick={() =>
                                        nav(
                                          `/AdminDashboard/EditWorkOrder/${technicalInwards.WorkOrderID}`,
                                        )
                                      }
                                      className="m-auto text-center"
                                      style={{
                                        width: "4rem",
                                        fontWeight: "600",
                                        padding: "7px 3px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: "0.1rem",
                                        background:
                                          "linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)",
                                        color: "white",
                                        borderRadius: "4px",
                                      }}
                                    >
                                      {t("Edit")}
                                    </button>
                                  </td>
                                  {/* <td className='py-2'>{technicalInwards.HeadCode}</td> */}
                                  {/* <td className='py-2'>{technicalInwards.GrID}</td> */}
                                  <td className="py-2">
                                    {technicalInwards.ProposalID}
                                  </td>
                                  <td className="py-2">
                                    {technicalInwards.ProposalYear}
                                  </td>
                                  <td className="py-2">
                                    {technicalInwards.talulka}
                                  </td>
                                  {/* <td className='py-2'>{technicalInwards.PanNo}</td> */}
                                  <td className="py-2">
                                    {technicalInwards.ContractorName}
                                  </td>
                                  <td className="py-2">
                                    {technicalInwards.WorkName}
                                  </td>
                                  <td className="py-2">
                                    {technicalInwards.WorkOrderType || "-"}
                                  </td>
                                  <td className="py-2">
                                    {formatIndianAmount(technicalInwards.ApprovedWorkAmount)}
                                  </td>
                                  {/* <td className="py-2">
                                    {technicalInwards.PaidAmount}
                                  </td> */}
                                  <td className="py-2">
                                    {formatIndianAmount(technicalInwards.RemainingAmount)}
                                  </td>
                                  {/* <td style={{ padding: '8px' }}>{
                                            technicalInwards.CopyofWorkOrder ?
                                                (<a href={`${apiurl}/WorkOrderDocsImages/${technicalInwards.CopyofWorkOrder}`} target='_blank'>{technicalInwards.CopyofWorkOrder}</a>)
                                                :
                                                (<p className='text-danger my-auto fw-bold'>No Copy</p>)
                                        }
                                        </td> */}
                                  <td style={{ padding: "8px" }}>
                                    {technicalInwards.Remark}
                                  </td>
                                </tr>
                              </tbody>
                            );
                          })
                        )}
                      </table>
                    </div>
                  </div>
                )}
              </div>

              <div className="col-12 mt-3">
                <div
                  className="my-2 d-flex justify-content-between align-items-center"
                  style={{ flexWrap: "wrap" }}
                >
                  <p>
                    {t("Showing")}{" "}
                    {showSpecificWorkDetail.length > 0
                      ? indexOfFirstBill + 1
                      : 0}{" "}
                    {t("to")}{" "}
                    {Math.min(indexOfLastBill, showSpecificWorkDetail?.length)}{" "}
                    {t("of")} {showSpecificWorkDetail?.length} {t("entries")}
                  </p>

                  <div className="col-6 text-end">
                    <GooglePagination
                                                currentPage={currentPage}
                                                totalPages={totalPages}
                                                onPageChange={setCurrentPage}
                                            />
                  </div>

                  <div
                    className="col-6 text-start"
                    style={{ display: "flex", justifyContent: "left" }}
                  >
                    <button
                      onClick={() => approveorrejectSelected("Approved")}
                      disabled={selectedBills.length <= 0 ? true : loading}
                      className="ms-0"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.3rem",
                        margin: "12px",
                        padding: "8px 10px",
                        fontWeight: "600",
                        backgroundColor:
                          selectedBills.length <= 0
                            ? "rgba(141, 141, 141, 0.97)"
                            : "#39B54A",
                        color: "white",
                        borderRadius: "8px",
                        cursor:
                          selectedBills.length <= 0
                            ? "not-allowed"
                            : loading
                              ? "not-allowed"
                              : "pointer",
                      }}
                    >
                      <img
                        src="/Approve-Selected32.png"
                        style={{
                          width: "1rem",
                          height: "1rem",
                          filter: "brightness(0) invert(1)",
                        }}
                      />{" "}
                      {loading ? "Processing..." : "Approve Selected"}
                    </button>

                    <button
                      onClick={() => rejectSendbackbeforecheckup(2)}
                      disabled={selectedBills.length <= 0 ? true : loading}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.3rem",
                        margin: "12px",
                        padding: "8px 10px",
                        fontWeight: "600",
                        background:
                          selectedBills.length <= 0
                            ? "rgba(141, 141, 141, 0.97)"
                            : "#C1272D",
                        color: "white",
                        borderRadius: "8px",
                        cursor:
                          selectedBills.length <= 0
                            ? "not-allowed"
                            : loading
                              ? "not-allowed"
                              : "pointer",
                      }}
                    >
                      <img
                        src="/Reject-Selected32.png"
                        style={{
                          width: "1rem",
                          height: "1rem",
                          filter: "brightness(0) invert(1)",
                        }}
                      />{" "}
                      {loading ? "Processing..." : "Reject Selected"}
                    </button>

                    {/* <button
                                                onClick={() => rejectSendbackbeforecheckup(3)} disabled={selectedBills.length <= 0 ? true : loading}
                                                style={{
                                                    display: 'flex', alignItems: 'center', gap: '3px', margin: '12px', padding: '8px 10px', fontWeight: "600",
                                                    background: selectedBills.length <= 0 ? (
                                                        'rgba(141, 141, 141, 0.97)'
                                                    ) : ('linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)'), color: 'white', borderRadius: '8px',
                                                    cursor: selectedBills.length <= 0 ? 'not-allowed' : loading ? 'not-allowed' : 'pointer'
                                                }}
                                            ><img src='/Send-Back-Selected32.png' style={{ width: '1rem', height: "1rem", filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Send Back Selected'}
                                            </button> */}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {rejectPanelhide === 2 && (
        <div className="col-12 RejectPanelContainer">
          <div className="Rejectpanel">
            <form action="">
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-3">
                    <label className="fw-bold">
                      Remark <span className="text-danger">*</span>
                    </label>
                  </div>
                  <div className="col-8">
                    <textarea
                      name=""
                      id=""
                      placeholder="Enter Remark"
                      value={remark}
                      onChange={(e) =>
                        setRemark(e.target.value.replace(/^\s+/, ""))
                      }
                    ></textarea>
                  </div>
                </div>
              </div>
            </form>
            <div className="col-12 ms-auto my-4">
              <div className="row">
                {/* <div className="col-3"></div> */}
                <div className="col-9 m-auto">
                  <div
                    className="col-12"
                    style={{
                      display: "flex",
                      gap: "10px",
                      justifyContent: "center",
                    }}
                  >
                    <button
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "4px",
                        background:
                          "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                        width: "5rem",
                        height: "2rem",
                        fontSize: "18px",
                      }}
                      onClick={() => approveorrejectSelected("Rejected")}
                    >
                      <img src={submit} style={{ width: "15px" }} /> Reject
                    </button>
                    <button
                      type="button"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "4px",
                        backgroundColor: "#f1594c",
                        width: "6rem",
                        height: "2rem",
                        fontSize: "18px",
                      }}
                      onClick={() => window.location.reload()}
                    >
                      {" "}
                      <img src={Cancel32} style={{ width: "17px" }} />
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {rejectPanelhide === 3 && (
        <div className="col-12 RejectPanelContainer">
          <div className="Rejectpanel">
            <form action="">
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-3">
                    <label className="fw-bold">
                      Remark <span className="text-danger">*</span>
                    </label>
                  </div>
                  <div className="col-8">
                    <textarea
                      name=""
                      id=""
                      placeholder="Enter Remark"
                      value={remark}
                      onChange={(e) =>
                        setRemark(e.target.value.replace(/^\s+/, ""))
                      }
                    ></textarea>
                  </div>
                </div>
              </div>
            </form>
            <div className="col-12 ms-auto my-4">
              <div className="row">
                {/* <div className="col-3"></div> */}
                <div className="col-9 m-auto">
                  <div
                    className="col-12"
                    style={{
                      display: "flex",
                      gap: "10px",
                      justifyContent: "center",
                    }}
                  >
                    <button
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "4px",
                        background:
                          "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                        width: "8rem",
                        height: "2rem",
                        fontSize: "18px",
                      }}
                      onClick={() => approveorrejectSelected("SendBack")}
                    >
                      <img src={submit} style={{ width: "15px" }} /> Send Back
                    </button>
                    <button
                      type="button"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "4px",
                        backgroundColor: "#f1594c",
                        width: "6rem",
                        height: "2rem",
                        fontSize: "18px",
                      }}
                      onClick={() => window.location.reload()}
                    >
                      {" "}
                      <img src={Cancel32} style={{ width: "17px" }} />
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default WorkOrderInwardList;
